/**
 * 동일한 문자가 세개 이상 반복하는지 검증
 * @returns boolean (true: 동일한 문자가 세개이상 반복함, false: 동일한 문자가 세개 이상 반복하지 않음)
 */

const validateLetterRepeatThreeTimes = (str: string) => {
  const REGEX_REPEAT_THREE_TIMES = /(.)\1\1/g;

  if (REGEX_REPEAT_THREE_TIMES.test(str)) {
    return true;
  }

  return false;
};

export default validateLetterRepeatThreeTimes;
